import React from 'react'

const CreditsTicketPsStranieri = ({children}) => {
  return <>
    <li><a href="https://it.freepik.com/search">Icona di Roundicons</a></li>
    <li><a href="https://www.freepik.com/search">Icon by Hight Quality Icons</a></li>
    <li><a href="https://it.freepik.com/search">Icona di Xinh Studio</a></li>    
    <li><a href="https://it.freepik.com/foto-gratuito/un-ufficio-moderno-sfocato-un-corridoio-vuoto-un-negozio-alla-luce-del-giorno_415059897.htm">Immagine di yogiermansyah22 su Freepik</a></li>
  </>
}

export default CreditsTicketPsStranieri